export default {
  MuiBadge: {
    colorPrimary: {
      backgroundColor: '#8BC34A',
    },
    colorSecondary: {
      backgroundColor: '#C4C4C4',
    },
    anchorOriginTopRightRectangle: {
      backgroundColor: '#E35141',
      borderRadius: 9,
      minWidth: 18,
      height: 18,
      transform: 'scale(1) translate(70%, -10%)',
      fontSize: 10,
      border: '1px solid white',
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/Badge.js